module.exports = __webpack_public_path__ + "assets/icon_appeal.2c955636.svg";